import { render, staticRenderFns } from "./NotificationHeader.vue?vue&type=template&id=3d2f3cb0&"
import script from "./NotificationHeader.vue?vue&type=script&lang=js&"
export * from "./NotificationHeader.vue?vue&type=script&lang=js&"
import style0 from "./NotificationHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports